/* eslint-disable eqeqeq */
import React, { FC } from "react";
import { useHistory, useRouteMatch } from "react-router-dom";
import { withProcedureWraper } from "../../../..";
import { Icon } from "../../../../../../components/icon";
import { MajorTableList } from "../../components/TableList";
import { EditTableList } from "../../components/TableList";
import { PATH } from "../../constant";

export const Create: FC = withProcedureWraper(() => {
  const { id } = useRouteMatch().params as any;
  const history = useHistory();
  
  return (
    <div className="ITCodeGrantedCreateNewPage">
      <div className="pd15">
        <div className="PageHead">
          <div className="title">
            <div className="btnBack" onClick={() => history.push(PATH.HOME)}>
              <Icon.ArrowLeft />
            </div>
            {id == "0"
              ? "TẠO BẢNG TỔNG HỢP NHÂN SỰ THAM GIA KHÓA HỌC"
              : "SỬA BẢNG TỔNG HỢP NHÂN SỰ THAM GIA KHÓA HỌC"}
          </div>
        </div>

        {id == "0" && <MajorTableList />}
        {id != "0" && <EditTableList />}
      </div>
    </div>
  );
});
